// Resolves the backend base URL.
// In a browser running on a real host (not localhost), prefer the same origin
// so the app keeps working when deployed behind a custom domain even if the
// build-time REACT_APP_BACKEND_URL points at a stale/decommissioned URL.
// In local development (localhost), fall back to the env var.
export const getBackendUrl = () => {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host && host !== "localhost" && host !== "127.0.0.1") {
      return window.location.origin;
    }
  }
  return process.env.REACT_APP_BACKEND_URL || "";
};
